export const formatNumber = (number: number) =>
  Intl.NumberFormat("de").format(number);

export const formatFirstChartUppercase = (word: string) =>
  word.charAt(0).toUpperCase() + word.slice(1);

export const formatTariffOptionLabel = (tariffOption: string | null) =>
  tariffOption ? tariffOption.replaceAll("ML", "").trim() : "";
